// Inferno color stops (11 stops, evenly spaced t=0..1)
// Sampled from matplotlib's inferno colormap
// Reference: https://github.com/matplotlib/matplotlib/blob/main/lib/matplotlib/_cm_listed.py
const INFERNO_STOPS: [number, number, number][] = [
  [0.001, 0.000, 0.014],
  [0.087, 0.044, 0.224],
  [0.223, 0.037, 0.388],
  [0.370, 0.069, 0.431],
  [0.519, 0.125, 0.420],
  [0.659, 0.206, 0.359],
  [0.797, 0.315, 0.243],
  [0.902, 0.450, 0.130],
  [0.969, 0.616, 0.022],
  [0.988, 0.800, 0.146],
  [0.988, 0.998, 0.645],
];

function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

export function mapHeight(z: number, zMin: number, zMax: number): [number, number, number] {
  const range = zMax - zMin;
  const t = range === 0 ? 0.5 : Math.max(0, Math.min(1, (z - zMin) / range));

  const scaled = t * (INFERNO_STOPS.length - 1);
  const idx = Math.min(Math.floor(scaled), INFERNO_STOPS.length - 2);
  const frac = scaled - idx;

  const a = INFERNO_STOPS[idx];
  const b = INFERNO_STOPS[idx + 1];

  return [lerp(a[0], b[0], frac), lerp(a[1], b[1], frac), lerp(a[2], b[2], frac)];
}

export function findZRange(positions: Float32Array, count: number): [number, number] {
  let zMin = Infinity;
  let zMax = -Infinity;
  for (let i = 0; i < count; i++) {
    const z = positions[i * 3 + 2];
    if (z < zMin) zMin = z;
    if (z > zMax) zMax = z;
  }
  return [zMin, zMax];
}

export function buildColorBuffer(positions: Float32Array, count: number): Float32Array {
  const [zMin, zMax] = findZRange(positions, count);
  const colors = new Float32Array(count * 3);

  for (let i = 0; i < count; i++) {
    const z = positions[i * 3 + 2];
    const [r, g, b] = mapHeight(z, zMin, zMax);
    colors[i * 3] = r;
    colors[i * 3 + 1] = g;
    colors[i * 3 + 2] = b;
  }

  return colors;
}
